module.exports = __webpack_public_path__ + "media/images/banks/vn-techcombank-468f623a6aceebad240615782e3728c4.png";